var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.998,
    viewBox: "0 0 40 39.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56989",
    "data-name": "Grupo 56989",
    transform: "translate(16.563 16.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56988",
    "data-name": "Grupo 56988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43349",
    "data-name": "Caminho 43349",
    d: "M218,211.02a3.516,3.516,0,1,0,0,4.972A3.514,3.514,0,0,0,218,211.02Zm-1.657,3.314a1.172,1.172,0,1,1,0-1.657A1.171,1.171,0,0,1,216.347,214.335Z",
    transform: "translate(-212.004 -209.99)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56991",
    "data-name": "Grupo 56991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56990",
    "data-name": "Grupo 56990",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43350",
    "data-name": "Caminho 43350",
    d: "M38.969,10.987a3.513,3.513,0,0,0-4.972,0l-5.635,5.635-4.972-4.972,5.635-5.635a3.516,3.516,0,0,0-4.972-4.972L18.419,6.678l-.829-.829a1.172,1.172,0,0,0-1.657,0l-4.739,4.739a10.521,10.521,0,0,0-2.869,9.526,5.876,5.876,0,0,1-1.094,4.957L4.678,28.355A3.521,3.521,0,0,0,4.967,33l.194.194L.343,38.012A1.172,1.172,0,0,0,2,39.669l4.818-4.818.194.194a3.521,3.521,0,0,0,4.644.289l3.284-2.555A5.875,5.875,0,0,1,19.9,31.7a10.527,10.527,0,0,0,9.526-2.884l4.739-4.739a1.172,1.172,0,0,0,0-1.657l-.829-.829,5.635-5.635A3.514,3.514,0,0,0,38.969,10.987ZM25.711,2.7a1.172,1.172,0,1,1,1.657,1.657L21.734,9.992,20.076,8.335ZM10.218,33.484a1.174,1.174,0,0,1-1.548-.1L6.624,31.342a1.174,1.174,0,0,1-.1-1.548l2.265-2.912,4.338,4.337ZM27.767,27.16A8.186,8.186,0,0,1,20.358,29.4a8.224,8.224,0,0,0-5.2.528l-5.074-5.074a8.189,8.189,0,0,0,.542-5.2,8.182,8.182,0,0,1,2.228-7.409l3.91-3.91L31.677,23.25ZM37.312,14.3l-5.635,5.635L30.02,18.278l5.635-5.635A1.172,1.172,0,0,1,37.312,14.3Z",
    transform: "translate(0 -0.015)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlug);
export default __webpack_public_path__ + "static/media/ico-plug.70e826e9eec7bc4542c14885a9e5ad66.svg";
export { ForwardRef as ReactComponent };